import * as React from 'react';
import { cn } from '@/lib/utils';

const BulletinBoardContainer = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-bulletin-board-container',
      // sytles
      'grid gap-y-2',
      className
    )}
    {...props}
  />
));
BulletinBoardContainer.displayName = 'BulletinBoardContainer';

const BulletinBoardItem = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-bulletin-board-item',
      // sytles
      'grid grid-cols-[152px_1fr] items-start gap-x-4',
      className
    )}
    {...props}
  />
));
BulletinBoardItem.displayName = 'BulletinBoardItem';

const BulletinBoardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-bulletin-board-title',
      // sytles
      'text-sm font-bold',
      className
    )}
    {...props}
  />
));
BulletinBoardTitle.displayName = 'BulletinBoardTitle';

const BulletinBoardImg = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn(
      'c-bulletin-board-img',
      // sytles
      'h-14 w-32 rounded-lg object-cover',
      className
    )}
    {...props}
  />
));
BulletinBoardImg.displayName = 'BulletinBoardImg';

const BulletinBoardBannerTitle = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'c-bulletin-board-banner-title',
      // sytles
      'flex-1 truncate text-sm font-bold text-primary-dark',
      className
    )}
    {...props}
  />
));
BulletinBoardBannerTitle.displayName = 'BulletinBoardBannerTitle';

const BulletinBoardProfiles = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-bulletin-board-profiles',
      // sytles
      'flex items-center gap-1',
      className
    )}
    {...props}
  />
));
BulletinBoardProfiles.displayName = 'BulletinBoardProfiles';

export { BulletinBoardContainer, BulletinBoardItem, BulletinBoardTitle, BulletinBoardImg, BulletinBoardBannerTitle, BulletinBoardProfiles };
